import './LeadCard.css';

function isOverdue(lead) {
  const now = Date.now();
  if (lead.next_follow_up_at && new Date(lead.next_follow_up_at) < now) return true;
  if (!lead.last_contacted_at && (now - new Date(lead.created_at)) / 86400000 > 3) return true;
  if (lead.last_contacted_at && !lead.next_follow_up_at &&
    (now - new Date(lead.last_contacted_at)) / 86400000 > 3) return true;
  return false;
}

function formatDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
}

const INTEREST_LABELS = { LOW: 'Low', MEDIUM: 'Medium', HIGH: 'High' };
const SOURCE_LABELS = {
  REFERRAL: 'Referral', EVENT: 'Event', WALK_IN: 'Walk-in',
  COLD_CALL: 'Cold call', DIGITAL: 'Digital', OTHER: 'Other'
};

function formatAum(val) {
  if (!val) return null;
  const l = val / 100000;
  if (l >= 100) return `₹${(l / 100).toFixed(1)}Cr`;
  return `₹${l % 1 === 0 ? l : l.toFixed(1)}L`;
}

export default function LeadCard({ lead, onClick }) {
  const overdue = isOverdue(lead);
  const hot = lead.hot_score > 70;
  const warm = !hot && lead.hot_score > 40;

  function handleDragStart(e) {
    e.dataTransfer.setData('leadId', lead._id);
    e.dataTransfer.effectAllowed = 'move';
  }

  return (
    <div
      className={`llc__card ${overdue ? 'llc__card--overdue' : ''} ${warm ? 'llc__card--warm' : ''}`}
      onClick={() => onClick(lead)}
      draggable
      onDragStart={handleDragStart}
    >
      {overdue && <span className="llc__overdue-badge">OVERDUE</span>}
      <div className="llc__name">
        {hot && '🔥 '}{lead.name}
      </div>
      <div className="llc__phone">{lead.phone}</div>

      <div className="llc__chips">
        {lead.source && (
          <span className="llc__chip llc__chip--source">
            {SOURCE_LABELS[lead.source] || lead.source}
          </span>
        )}
        {lead.interest_level && (
          <span className={`llc__chip llc__chip--interest llc__chip--interest-${lead.interest_level.toLowerCase()}`}>
            {INTEREST_LABELS[lead.interest_level]}
          </span>
        )}
        {lead.estimated_aum > 0 && (
          <span className="llc__chip llc__chip--aum">{formatAum(lead.estimated_aum)}</span>
        )}
      </div>

      <div className="llc__meta">
        <span className="llc__touchpoints">
          {(lead.touchpoints || []).length} touchpoint{(lead.touchpoints || []).length !== 1 ? 's' : ''}
        </span>
        {lead.last_contacted_at && (
          <span className="llc__last-contact">Last: {formatDate(lead.last_contacted_at)}</span>
        )}
      </div>

      {lead.next_follow_up_at && !overdue && (
        <div className="llc__follow-up">
          Follow up: {formatDate(lead.next_follow_up_at)}
        </div>
      )}
    </div>
  );
}
